import { render } from "./LabelOrderPage.vue?vue&type=template&id=faf67752"
import script from "./LabelOrderPage.vue?vue&type=script&lang=js"
export * from "./LabelOrderPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__